module.exports = __webpack_public_path__ + "static/media/setting.63acb4bc.png";